import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 20);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && isOpen) {
                setIsOpen(false);
                const menuButton = document.querySelector('[aria-controls="mobile-menu"]');
                if (menuButton) menuButton.focus();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen]);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);


    // Updated Link Class Functions in Navbar.jsx

const navLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `relative px-4 py-4 text-lg font-medium border-none
            transition-all duration-300 ease-in-out 
            flex items-center min-h-[44px] min-w-[44px] text-nowrap
            hover:text-heritage-gold focus:outline-none focus:text-heritage-gold
            ${isActive ? "text-heritage-gold active-link" : "text-white"}

            ${isActive ? "after:w-full" : "after:w-0"}`;
};

const mobileNavLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `flex items-center w-full px-6 py-4 text-base font-medium 
           
            transition-all duration-300 ease-in-out 
            hover:bg-white/10 focus:outline-none focus:bg-white/10 focus:text-heritage-gold
            ${isActive ? "text-heritage-gold active-link bg-white/5" : "text-white"}`;
};

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out
                        ${isScrolled ? "bg-heritage-maroon/95 backdrop-blur-md shadow-strong" : "bg-heritage-maroon"}`}
             role="navigation"
             aria-label="Main navigation">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex-shrink-0 flex items-center">
                        <Link 
                            to="/" 
                            className="text-2xl font-serif font-bold text-white hover:text-heritage-gold 
                                     min-h-[44px] min-w-[44px] flex items-center px-2
                                     transition-colors duration-200 ease-in-out focus:outline-none focus:text-heritage-gold"
                            aria-label="Prof. Bihari Lal Sharma - Home page"
                        >
                            Prof. Bihari Lal Sharma
                        </Link>
                    </div>

                    <div className="hidden md:block">
                        <div className="ml-10 flex items-center space-x-1" role="menubar">
                            <Link to="/" className={navLinkClass("/")} role="menuitem">Home</Link>
                            <Link to="/career-highlights" className={navLinkClass("/career-highlights")} role="menuitem">Career Highlights</Link>
                            <Link to="/qualifications-experience" className={navLinkClass("/qualifications-experience")} role="menuitem">Qualifications & Experience</Link>
                            <Link to="/research" className={navLinkClass("/research")} role="menuitem" aria-current={location.pathname === "/research" ? "page" : undefined}>Research Articles & Books</Link>
                            <Link to="/gallery" className={navLinkClass("/gallery")} role="menuitem">Photo Gallery</Link>
                        </div>
                    </div>

                    <div className="md:hidden flex items-center">
                       
                        <button
                            onClick={toggleMenu}
                            className="inline-flex items-center justify-center p-3 rounded-md text-white 
                                       min-w-[44px] min-h-[44px]
                                       hover:text-heritage-gold focus:outline-none focus:text-heritage-gold transition-all duration-200"
                            aria-expanded={isOpen}
                            aria-label={isOpen ? "Close menu" : "Open menu"}
                        >
                            <span className="sr-only">{isOpen ? "Close menu" : "Open main menu"}</span>
                            {isOpen ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            <div 
                id="mobile-menu"
                className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden
                           ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
                aria-hidden={!isOpen}
            >
                <div className="px-2 pt-2 pb-6 space-y-1 bg-heritage-maroon/98 border-t border-white/10" role="menu">
                    <Link to="/" className={mobileNavLinkClass("/")} onClick={closeMenu} role="menuitem">Home</Link>
                    <Link to="/career-highlights" className={mobileNavLinkClass("/career-highlights")} onClick={closeMenu} role="menuitem">Career Highlights</Link>
                    <Link to="/qualifications-experience" className={mobileNavLinkClass("/qualifications-experience")} onClick={closeMenu} role="menuitem">Qualifications & Experience</Link>
                    <Link to="/research" className={mobileNavLinkClass("/research")} onClick={closeMenu} role="menuitem" aria-current={location.pathname === "/research" ? "page" : undefined}>Research Articles & Books</Link>
                    <Link to="/gallery" className={mobileNavLinkClass("/gallery")} onClick={closeMenu} role="menuitem">Photo Gallery</Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;